(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-lp-bretagne-story"]) return;
  try {
    
(function () {
  var root = document.getElementById('bc-lp-bretagne-story');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Reveal system ──────────────────────────────────────────────── */
  root.classList.add('js-reveal-ready');
  if (reduceMotion) {
    root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-revealed'); });
  } else if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    root.querySelectorAll('.reveal').forEach(function (el) { revealObserver.observe(el); });
  } else {
    root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /* ── Count-up helper (exponential ease-out, used by StatsBanner) ──── */
  function countUpExpo(el, target, prefix, suffix, duration) {
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = (prefix || '') + Math.round(eased * target).toLocaleString('fr-FR') + (suffix || '');
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = (prefix || '') + target.toLocaleString('fr-FR') + (suffix || '');
    }
    requestAnimationFrame(frame);
  }

  /* ── Count-up helper (cubic ease-out, used by Racines) ─────────────── */
  function countUpCubic(el, target, suffix, duration) {
    var start = null;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(eased * target).toLocaleString('fr-FR') + (suffix || '');
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = target.toLocaleString('fr-FR') + (suffix || '');
    }
    requestAnimationFrame(frame);
  }

  /* ── StatsBanner count-up (1400ms, exponential) ────────────────────── */
  var statsRoot = root.querySelector('[data-stats-root]');
  if (statsRoot) {
    var statsRun = false;
    function runStats() {
      if (statsRun) return;
      statsRun = true;
      statsRoot.querySelectorAll('[data-stat-count]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-stat-count'), 10) || 0;
        var prefix = el.getAttribute('data-stat-prefix') || '';
        var suffix = el.getAttribute('data-stat-suffix') || '';
        if (reduceMotion) { el.textContent = prefix + target.toLocaleString('fr-FR') + suffix; return; }
        countUpExpo(el, target, prefix, suffix, 1400);
      });
    }
    if ('IntersectionObserver' in window && !reduceMotion) {
      var statsObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { runStats(); statsObserver.disconnect(); }
        });
      }, { threshold: 0.2 });
      statsObserver.observe(statsRoot);
    } else {
      runStats();
    }
  }

  /* ── Racines count-up (1200ms, cubic ease-out) ─────────────────────── */
  var racinesStatsRoot = root.querySelector('[data-racines-stats-root]');
  var racinesStatsWrap = root.querySelector('#racines .endro-racines__stats');
  if (racinesStatsWrap) {
    var racinesRun = false;
    function runRacines() {
      if (racinesRun) return;
      racinesRun = true;
      racinesStatsWrap.querySelectorAll('[data-racine-count]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-racine-count'), 10) || 0;
        var suffix = el.getAttribute('data-racine-suffix') || '';
        if (reduceMotion) { el.textContent = target.toLocaleString('fr-FR') + suffix; return; }
        countUpCubic(el, target, suffix, 1200);
      });
    }
    if ('IntersectionObserver' in window && !reduceMotion) {
      var racinesObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { runRacines(); racinesObserver.disconnect(); }
        });
      }, { threshold: 0.3 });
      racinesObserver.observe(racinesStatsWrap);
    } else {
      runRacines();
    }
  }

  /* ── Marche: year-tab crossfade ─────────────────────────────────── */
  var marcheRoot = root.querySelector('[data-marche-root]');
  if (marcheRoot) {
    var marcheTabs = Array.prototype.slice.call(marcheRoot.querySelectorAll('[data-marche-tab]'));
    var marcheImages = Array.prototype.slice.call(marcheRoot.querySelectorAll('[data-marche-image]'));
    var marchePanels = Array.prototype.slice.call(marcheRoot.querySelectorAll('[data-marche-panel]'));
    var marcheIndex = 0;

    function setMarche(i) {
      marcheIndex = (i + marcheTabs.length) % marcheTabs.length;
      marcheTabs.forEach(function (tab, idx) {
        var active = idx === marcheIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      marcheImages.forEach(function (img, idx) { img.classList.toggle('is-active', idx === marcheIndex); });
      marchePanels.forEach(function (panel, idx) {
        var active = idx === marcheIndex;
        panel.classList.toggle('is-active', active);
        panel.style.display = active ? '' : 'none';
        if (active && !reduceMotion) {
          panel.style.animation = 'none';
          void panel.offsetWidth;
          panel.style.animation = 'bc-content-swap 0.4s ease-out';
        }
      });
    }
    marchePanels.forEach(function (panel, idx) { panel.style.display = idx === 0 ? '' : 'none'; });

    marcheTabs.forEach(function (tab, idx) {
      tab.addEventListener('click', function () { setMarche(idx); });
    });
    var marchePrev = marcheRoot.querySelector('[data-marche-prev]');
    var marcheNext = marcheRoot.querySelector('[data-marche-next]');
    if (marchePrev) marchePrev.addEventListener('click', function () { setMarche(marcheIndex - 1); });
    if (marcheNext) marcheNext.addEventListener('click', function () { setMarche(marcheIndex + 1); });
  }

  /* ── Horizontal scroll-snap carousels (Products / Categories) ─────── */
  root.querySelectorAll('[data-carousel]').forEach(function (track) {
    var name = track.getAttribute('data-carousel');
    var prevBtn = root.querySelector('[data-carousel-prev="' + name + '"]');
    var nextBtn = root.querySelector('[data-carousel-next="' + name + '"]');
    function step() {
      var firstChild = track.children[0];
      var w = firstChild ? firstChild.getBoundingClientRect().width : 300;
      return w + 24;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ── Racines photo gallery: nav + edge-fade ────────────────────────── */
  var galleryRoot = root.querySelector('[data-racines-gallery-root]');
  if (galleryRoot) {
    var galleryTrack = galleryRoot.querySelector('[data-racines-track]');
    var fadeLeft = galleryRoot.querySelector('[data-racines-fade="left"]');
    var fadeRight = galleryRoot.querySelector('[data-racines-fade="right"]');
    var galleryPrev = galleryRoot.querySelector('[data-racines-gallery-prev]');
    var galleryNext = galleryRoot.querySelector('[data-racines-gallery-next]');

    function updateFade() {
      if (!galleryTrack) return;
      var maxScroll = galleryTrack.scrollWidth - galleryTrack.clientWidth;
      var atStart = galleryTrack.scrollLeft <= 4;
      var atEnd = galleryTrack.scrollLeft >= maxScroll - 4;
      if (fadeLeft) fadeLeft.classList.toggle('is-visible', !atStart);
      if (fadeRight) fadeRight.classList.toggle('is-visible', maxScroll > 4 && !atEnd);
    }
    function galleryStep() {
      var firstChild = galleryTrack.children[0];
      var w = firstChild ? firstChild.getBoundingClientRect().width : 220;
      return w + 16;
    }
    if (galleryTrack) {
      galleryTrack.addEventListener('scroll', updateFade, { passive: true });
      window.addEventListener('resize', updateFade);
      updateFade();
    }
    if (galleryPrev) galleryPrev.addEventListener('click', function () { galleryTrack.scrollBy({ left: -galleryStep(), behavior: 'smooth' }); });
    if (galleryNext) galleryNext.addEventListener('click', function () { galleryTrack.scrollBy({ left: galleryStep(), behavior: 'smooth' }); });
  }

  /* ── FAQ accordion ──────────────────────────────────────────────── */
  var faqRoot = root.querySelector('[data-faq-root]');
  if (faqRoot) {
    var faqItems = Array.prototype.slice.call(faqRoot.querySelectorAll('[data-faq-item]'));
    faqItems.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        faqItems.forEach(function (other) {
          other.classList.remove('is-open');
          var t = other.querySelector('[data-faq-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── StickyBar: visibility (IO on #racines) + body padding (RO) ───── */
  var stickyBar = root.querySelector('[data-sticky-bar]');
  var racinesSection = document.getElementById('racines');
  if (stickyBar && racinesSection && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = entry.boundingClientRect.top < window.innerHeight * 0.5;
        stickyBar.classList.toggle('is-visible', visible);
      });
    }, { threshold: 0 });
    stickyObserver.observe(racinesSection);
  }
  if (stickyBar && 'ResizeObserver' in window) {
    var bodyPadObserver = new ResizeObserver(function () {
      if (stickyBar.classList.contains('is-visible')) {
        document.body.style.paddingBottom = stickyBar.offsetHeight + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    });
    bodyPadObserver.observe(stickyBar);
    var mo = new MutationObserver(function () {
      if (stickyBar.classList.contains('is-visible')) {
        document.body.style.paddingBottom = stickyBar.offsetHeight + 'px';
      } else {
        document.body.style.paddingBottom = '';
      }
    });
    mo.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-lp-palette-decouverte"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function getData() { return window.ENDRO_PD || { products: {}, order: [], selectionSize: 6 }; }

  // state.selected  : la palette en cours de composition (jusqu'a six soins).
  // state.palettes  : les palettes deja validees et presentes au panier, figees.
  // state.pousse    : ce que la LP a ecrit dans le panier (variantId -> quantite),
  //                   pour savoir quoi remettre a zero quand la selection change.
  var state = { selected: [], palettes: [], pousse: {}, message: '', messageTimer: null, openDrawerId: null, giftPopupShown: false, giftPopupTimer: null, activeType: '', hasAutoOpenedCartDrawer: false, cartSynced: false };

  function applyFilter() {
    document.querySelectorAll('[data-endro-filter]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-endro-filter') === state.activeType;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    document.querySelectorAll('[data-endro-card]').forEach(function (card) {
      card.hidden = !!state.activeType && card.getAttribute('data-endro-type') !== state.activeType;
    });
  }
  var isConfiguratorInView = true;

  var GAMME_COLORS = { hydratation: '#5F8FB4', 'anti-age': '#A7A2C3', eclat: '#F1B434', matifiant: '#6B8D73', nettoyant: '#DF8877' };

  function buildStarsSvg(rating, idPrefix) {
    var html = '';
    for (var s = 0; s < 5; s++) {
      var fill = rating - s;
      if (fill > 1) fill = 1;
      if (fill < 0) fill = 0;
      var pct = Math.round(fill * 100);
      var gradId = idPrefix + '-' + s;
      html += '<svg viewBox="0 0 18 18" width="12" height="12" xmlns="http://www.w3.org/2000/svg">' +
        '<defs><linearGradient id="' + gradId + '">' +
        '<stop offset="' + pct + '%" stop-color="rgb(23,50,33)" stop-opacity="1" />' +
        '<stop offset="' + pct + '%" stop-color="#D9D9D9" stop-opacity="1" /></linearGradient></defs>' +
        '<path d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" fill="url(#' + gradId + ')" /></svg>';
    }
    return html;
  }

  function isComplete() { return state.selected.length === getData().selectionSize; }
  function isSelected(id) { return state.selected.indexOf(id) !== -1; }

  // Plafond de palettes par commande, desactive par defaut : la reduction
  // « palettedecouverte » n'a plus de limite d'utilisations par commande, donc
  // chaque palette achetee donne bien ses six minis offerts. Si Endro remet un
  // plafond sur la reduction, cocher la limitation et l'aligner dessus — sinon
  // les minis des palettes au-dela seraient factures.
  function maxPalettes() {
    var d = getData();
    if (!d.limiterPalettes) return Infinity;
    var n = parseInt(d.maxPalettes, 10);
    return n > 0 ? n : 1;
  }
  function nbPalettes() { return state.palettes.length + (isComplete() ? 1 : 0); }
  function peutComposerSuivante() { return isComplete() && state.cartSynced && nbPalettes() < maxPalettes(); }

  // Un soin peut figurer dans les deux palettes : sa ligne panier passe alors a
  // la quantite 2. Rien n'est donc suppose sur les quantites, ni ici ni dans la
  // reconciliation — et le stock reellement obtenu est verifie apres coup, deux
  // minis n'ayant qu'un seul exemplaire disponible.
  function toggle(id) {
    var d = getData();
    var product = d.products[id];
    if (!product || product.soldOut) return;
    if (state.message) { clearTimeout(state.messageTimer); state.message = ''; }

    if (isSelected(id)) {
      state.selected = state.selected.filter(function (x) { return x !== id; });
    } else {
      if (state.selected.length >= d.selectionSize) return;
      state.selected.push(id);
    }
    render();

    // La LP possede deja des lignes au panier : on les realigne. Les quantites
    // etant absolues, l'appel est idempotent — un aller-retour ajout/retrait ne
    // duplique rien, et une palette redevenue incomplete perd sa ligne Palette
    // plutot que de facturer 19,90 EUR pour moins de six soins.
    // Quand ce clic complete la palette, on laisse faire maybeAutoOpenCartDrawer :
    // c'est lui qui ecrit puis ouvre le drawer.
    if (state.cartSynced && !isComplete()) synchroniserLePanier().then(rafraichirPanier).catch(function () {});

    maybeAutoOpenCartDrawer();
  }

  // Au 6e produit ajouté, on ajoute réellement les 6 produits au panier Shopify
  // (parité avec React, qui ajoute vraiment au panier) puis on ouvre le drawer
  // natif du thème — un seul déclenchement par palette complétée (se réarme si
  // l'utilisateur retire un produit, voir toggle()).
  function maybeAutoOpenCartDrawer() {
    if (isComplete()) {
      if (state.hasAutoOpenedCartDrawer) return;
      state.hasAutoOpenedCartDrawer = true;
      syncCartAndOpenDrawer();
    } else {
      state.hasAutoOpenedCartDrawer = false;
    }
  }

  // ── Ecriture du panier ────────────────────────────────────────────────
  // Une seule fonction ecrit dans le panier, et elle ecrit TOUT l'etat d'un
  // coup, en quantites absolues via /cart/update.js. Deux raisons :
  //   - update.js fixe les quantites au lieu de cumuler comme add.js, donc
  //     rejouer l'appel ne double jamais les lignes ;
  //   - en passant par un point unique, on peut remettre a zero ce que la LP
  //     avait pousse et qui n'a plus lieu d'etre, sans toucher aux autres
  //     produits que la cliente a mis au panier de son cote.
  // Les minis partent en VRAIES lignes produit, plus la fiche « Palette
  // Découverte » qui porte les 19,90 EUR : c'est ce qui permet a Shippingbo de
  // voir quoi preparer et a Shopify de decrementer le stock. Une reduction
  // automatique ramene les minis a 0 EUR.
  function panierVoulu() {
    var d = getData();
    var updates = {};
    var toutes = state.palettes.slice();
    if (isComplete()) toutes.push(state.selected);
    toutes.forEach(function (pal) {
      pal.forEach(function (id) {
        var p = d.products[id];
        if (!p || !p.variantId) return;
        var v = parseInt(p.variantId, 10);
        updates[v] = (updates[v] || 0) + 1;
      });
    });
    if (d.paletteVariantId && toutes.length) updates[parseInt(d.paletteVariantId, 10)] = toutes.length;
    return updates;
  }

  // Les ecritures sont mises en file. Deux appels concurrents partent sinon du
  // meme etat : au 6e soin, le clic declenche une ecriture et l'ouverture
  // automatique du drawer en declenche une seconde. Toutes deux constataient le
  // meme depassement de stock et le corrigeaient chacune de leur cote — deux
  // retraits pour un seul soin en trop, et la premiere palette y passait.
  var ecritureEnCours = null;
  function synchroniserLePanier() {
    var suivante = function () { return ecrireLePanier(); };
    ecritureEnCours = ecritureEnCours ? ecritureEnCours.then(suivante, suivante) : suivante();
    return ecritureEnCours;
  }

  function ecrireLePanier() {
    var updates = panierVoulu();
    Object.keys(state.pousse).forEach(function (vid) {
      if (!(vid in updates)) updates[vid] = 0;
    });
    if (!Object.keys(updates).length) { state.cartSynced = false; return Promise.resolve(null); }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/update.js HTTP ' + res.status);
      return res.json();
    }).then(function (cart) {
      // Shopify rabote silencieusement une quantite qui depasse le stock. Sans
      // ce controle, une cliente qui reprend un soin a un seul exemplaire
      // repartirait avec onze minis pour deux palettes, sans que rien ne le dise.
      var obtenu = {};
      if (cart && cart.items) cart.items.forEach(function (it) { obtenu[String(it.variant_id)] = it.quantity; });
      state.pousse = {};
      var rabote = [];
      Object.keys(updates).forEach(function (vid) {
        var voulu = updates[vid];
        if (voulu <= 0) return;
        var reel = obtenu[String(vid)] || 0;
        if (reel > 0) state.pousse[vid] = reel;
        if (cart && cart.items && reel < voulu) rabote.push({ vid: String(vid), manque: voulu - reel });
      });
      state.cartSynced = Object.keys(state.pousse).length > 0;
      if (rabote.length) libererLesSoinsIndisponibles(rabote);
      return cart;
    });
  }

  // Un soin que le stock n'a pas suivi est retire de la palette en cours, la plus
  // recente : la cliente voit son emplacement se rouvrir et en choisit un autre,
  // plutot que de decouvrir une palette incomplete a la livraison.
  function libererLesSoinsIndisponibles(rabote) {
    var d = getData();
    var parVariant = {};
    Object.keys(d.products).forEach(function (id) {
      var p = d.products[id];
      if (p && p.variantId) parVariant[String(p.variantId)] = id;
    });
    var retires = [];
    rabote.forEach(function (r) {
      var id = parVariant[r.vid];
      if (!id) return;
      for (var n = 0; n < r.manque; n++) {
        var i = state.selected.lastIndexOf(id);
        if (i !== -1) { state.selected.splice(i, 1); retires.push(id); continue; }
        for (var k = state.palettes.length - 1; k >= 0; k--) {
          var j = state.palettes[k].lastIndexOf(id);
          if (j !== -1) { state.palettes[k].splice(j, 1); retires.push(id); break; }
        }
      }
    });
    if (!retires.length) return;
    // Une palette validee amputee n'a plus six soins : on l'abandonne en entier
    // plutot que de facturer 19,90 EUR pour moins, comme partout ailleurs ici.
    state.palettes = state.palettes.filter(function (pal) { return pal.length === d.selectionSize; });
    state.hasAutoOpenedCartDrawer = isComplete();
    var noms = retires.map(function (id) { return (d.products[id] || {}).name || id; });
    var msg = (d.labels && d.labels.stockInsuffisant) || 'Stock insuffisant pour {produits} en double, emplacement rouvert.';
    // Le message vit dans l'etat et non dans le DOM : ecrit directement, le rendu
    // declenche juste apres par l'ecriture panier l'effacait aussitot.
    state.message = msg.replace('{produits}', noms.join(', '));
    clearTimeout(state.messageTimer);
    state.messageTimer = setTimeout(function () { state.message = ''; render(); }, 7000);
    render();
    synchroniserLePanier().then(rafraichirPanier).catch(function () {});
  }

  function syncCartAndOpenDrawer() {
    synchroniserLePanier().then(function () {
      render();
      // Beaucoup de thèmes (Dawn et dérivés) écoutent cet évènement pour
      // rafraîchir le contenu du drawer après un ajout AJAX au panier.
      rafraichirPanier();
      openThemeCartDrawer();
    }).catch(function (err) {
      console.error('[BC] Echec de l ajout automatique au panier (drawer):', err);
      state.hasAutoOpenedCartDrawer = false;
      // L'ajout AJAX réel a échoué (store indisponible, réseau, ou — en preview
      // locale hors thème Shopify — endpoint /cart/update.js inexistant). On
      // ramène la barre de récap dans le viewport pour que la cliente voie
      // l'état « palette complète » et puisse retenter via le CTA manuel.
      showLocalRecapFallback();
    });
  }

  // Fallback visuel local utilisé quand le vrai drawer Shopify ne peut pas
  // être piloté (pas d'élément <cart-drawer> du thème — cas de la preview
  // locale hors store réel — ou échec de l'appel AJAX cart). Ramène la barre
  // de récap dans le viewport ; n'affiche jamais de fausses données panier.
  function showLocalRecapFallback() {
    var recapBar = document.querySelector('[data-recap-cta]') || document.getElementById('configurateur');
    if (recapBar) recapBar.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function rafraichirPanier() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // ── Composer une palette de plus ──────────────────────────────────────
  // La palette en cours est deja au panier : on la fige et on repart d'une
  // barre vide. Aucune ecriture panier ici, rien ne change cote Shopify.
  function composerPaletteSuivante() {
    if (!peutComposerSuivante()) return;
    state.palettes.push(state.selected.slice());
    state.selected = [];
    state.hasAutoOpenedCartDrawer = false;
    state.giftPopupShown = false;
    render();
    var config = document.getElementById('configurateur');
    if (config) config.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Rehydratation au chargement ───────────────────────────────────────
  // Sans ca, une cliente qui recharge la page repart d'une barre vide alors que
  // ses lignes sont toujours au panier : en composant une nouvelle palette elle
  // se retrouverait avec douze minis pour une seule ligne Palette, donc six
  // minis factures.
  // Les lignes a 0 EUR sont prises en premier : ce sont celles que la reduction
  // a couvertes, donc a coup sur des minis de palette. Un soin achete au prix
  // normal a cote (le contour des yeux se vend aussi seul) n'est absorbe qu'en
  // dernier recours.
  function rehydraterDepuisLePanier() {
    var d = getData();
    if (!d.paletteVariantId) return;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var parVariant = {};
        Object.keys(d.products).forEach(function (id) {
          var p = d.products[id];
          if (p && p.variantId) parVariant[String(p.variantId)] = id;
        });
        var idPalette = String(d.paletteVariantId);
        var qtePalette = 0;
        var gratuits = [];
        var payants = [];
        var lignes = {};
        cart.items.forEach(function (it) {
          var vid = String(it.variant_id);
          if (vid === idPalette) { qtePalette = it.quantity; lignes[vid] = it.quantity; return; }
          var id = parVariant[vid];
          if (!id) return;
          lignes[vid] = it.quantity;
          for (var k = 0; k < it.quantity; k++) (it.final_price === 0 ? gratuits : payants).push(id);
        });
        var minis = gratuits.concat(payants);
        var taille = d.selectionSize;
        if (!qtePalette || minis.length < taille) return;
        var completes = Math.min(qtePalette, Math.floor(minis.length / taille));
        state.palettes = [];
        for (var i = 0; i < completes; i++) state.palettes.push(minis.slice(i * taille, (i + 1) * taille));
        state.selected = minis.slice(completes * taille, completes * taille + taille);
        state.pousse = lignes;
        state.cartSynced = true;
        state.hasAutoOpenedCartDrawer = true;
        render();
        // La ligne Palette peut ne plus correspondre au nombre de palettes
        // (quantite modifiee a la main dans le drawer) : on realigne.
        if (qtePalette !== nbPalettes()) return synchroniserLePanier().then(rafraichirPanier);
      })
      .catch(function () { /* panier injoignable : on ne touche a rien */ });
  }

  function openThemeCartDrawer() {
    // Élément custom <cart-drawer> du thème (Dawn / OS 2.0 et dérivés type
    // Fox/FoxKit — cf. sections/cart-drawer.liquid + assets/cart.js d'autres
    // exports Shopify de ce repo, qui définissent `class CartDrawer extends
    // DrawerComponent extends ModalComponent`).
    var nativeDrawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');

    if (nativeDrawer) {
      // IMPORTANT : sur le thème de référence de ce repo (Fox/FoxKit, cf.
      // 05-Exports/nutripure/.../assets/theme.js), la classe ModalComponent
      // expose une méthode .show(open ? hide : show) — PAS de méthode
      // .open(). `.open` y est un GETTER booléen (`hasAttribute('open')`).
      // Appeler .open() en supposant que c'est une fonction laissait donc le
      // drawer fermé même sur un vrai thème Shopify (pas seulement en preview
      // locale) : `typeof nativeDrawer.open` valait 'boolean', jamais
      // 'function', donc ce chemin n'était JAMAIS emprunté et on retombait
      // sur un fallback par classes CSS qui ne correspond pas au modèle
      // d'état réel de ce thème (attribut `open`, pas des classes
      // `active`/`is-open`/`drawer--is-open`).
      if (typeof nativeDrawer.show === 'function') {
        nativeDrawer.show();
        return;
      }
      // Autres thèmes/versions qui exposent réellement .open() en méthode.
      if (typeof nativeDrawer.open === 'function') {
        nativeDrawer.open();
        return;
      }
      // Approche générique agnostique du thème : simuler un clic sur le
      // bouton panier natif du header (icône panier), qui pointe vers le
      // drawer via aria-controls="<id-du-drawer>". Ce bouton porte déjà le
      // vrai gestionnaire de clic du thème (ouverture + focus trap + verrou
      // de scroll), donc c'est la méthode la plus fiable quand on ne connaît
      // pas l'API JS exacte du thème installé chez le client.
      if (nativeDrawer.id) {
        var trigger = document.querySelector('[aria-controls="' + nativeDrawer.id + '"]');
        if (trigger) {
          trigger.click();
          return;
        }
      }
      // Dernier recours si aucune API connue n'a fonctionné : on simule
      // l'état "ouvert" au niveau attribut (et pas seulement classes), car
      // c'est l'attribut `open` que le CSS des thèmes de ce type cible
      // (sélecteurs du type cart-drawer[open]), en plus des classes
      // génériques utilisées par d'autres familles de thèmes.
      nativeDrawer.setAttribute('open', '');
      nativeDrawer.setAttribute('active', '');
      nativeDrawer.classList.add('active', 'is-open', 'drawer--is-open');
      nativeDrawer.removeAttribute('hidden');
      // Event standard écouté par de nombreux thèmes pour ouvrir le panier
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      return;
    }

    // Aucun élément <cart-drawer> du thème trouvé dans le DOM (cas de la
    // preview locale _preview/render.mjs, qui ne charge pas un vrai thème
    // Shopify) : on retombe sur le fallback visuel local.
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    showLocalRecapFallback();
  }

  function formatEuro(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function render() {
    var d = getData();
    var complete = isComplete();
    var remaining = Math.max(0, d.selectionSize - state.selected.length);

    document.querySelectorAll('[data-endro-card]').forEach(function (card) {
      var id = card.getAttribute('data-endro-card');
      var product = d.products[id];
      var selected = isSelected(id);
      var soldOut = !!(product && product.soldOut);
      var l = d.labels || {};
      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-blocked', !selected && complete);
      card.classList.toggle('is-soldout', soldOut);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');

      var toggleBtn = card.querySelector('[data-endro-toggle]');
      if (toggleBtn) {
        toggleBtn.disabled = soldOut || (!selected && complete);
        toggleBtn.setAttribute('aria-pressed', selected ? 'true' : 'false');
        toggleBtn.textContent = soldOut
          ? (l.soldOut || 'Rupture de stock')
          : (selected ? (l.removeProduct || 'Retirer le produit') : (l.addProduct || 'Ajouter +'));
      }
    });

    var statusEl = document.querySelector('[data-recap-status]');
    if (statusEl && state.message) {
      statusEl.textContent = state.message;
    } else if (statusEl) {
      statusEl.textContent = complete
        ? ((d.labels && d.labels.paletteComplete) || 'Votre palette est complète !')
        : (remaining === 1
            ? ((d.labels && d.labels.productRemainingSingular) || 'Plus qu’1 produit pour compléter votre palette')
            : ((d.labels && d.labels.productsRemainingTemplate) || 'Plus que {count} produits pour compléter votre palette').replace('{count}', remaining));
    }

    var statusGiftEl = document.querySelector('[data-recap-status-gift]');
    if (statusGiftEl) statusGiftEl.classList.toggle('is-incomplete', !complete);

    var giftSlotWrap = document.querySelector('[data-recap-gift-slot-img-wrap]');
    if (giftSlotWrap) giftSlotWrap.classList.toggle('is-complete', complete);

    if (complete && !state.giftPopupShown) {
      state.giftPopupShown = true;
      var giftPopup = document.querySelector('[data-recap-gift-popup]');
      if (giftPopup) {
        giftPopup.hidden = false;
        clearTimeout(state.giftPopupTimer);
        state.giftPopupTimer = setTimeout(function () {
          giftPopup.hidden = true;
        }, 5000);
      }
    }

    var slotsEl = document.querySelector('[data-recap-slots]');
    if (slotsEl) {
      slotsEl.innerHTML = '';
      for (var i = 0; i < d.selectionSize; i++) {
        var id = state.selected[i];
        var product = id ? d.products[id] : null;
        if (!product) {
          var invite = document.createElement('button');
          invite.type = 'button';
          invite.className = 'endro-pd-recap-invite endro-invite-pulse';
          invite.setAttribute('data-recap-goto', '');
          invite.setAttribute('aria-label', (d.labels && d.labels.addProductAria) || 'Ajouter un produit');
          invite.textContent = '+';
          slotsEl.appendChild(invite);
          continue;
        }
        var slot = document.createElement('div');
        slot.className = 'endro-pd-recap-slot';

        var thumbBtn = document.createElement('button');
        thumbBtn.type = 'button';
        thumbBtn.className = 'endro-pd-recap-thumb';
        thumbBtn.setAttribute('data-recap-remove', id);
        thumbBtn.setAttribute('aria-label', ((d.labels && d.labels.removeProductAriaPrefix) || 'Retirer ') + (product.name || ''));

        var frame = document.createElement('span');
        frame.className = 'endro-pd-recap-thumb-frame';
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = product.name || '';
        frame.appendChild(img);
        thumbBtn.appendChild(frame);
        thumbBtn.insertAdjacentHTML('beforeend', '<span class="endro-pd-recap-thumb-x" aria-hidden="true"><svg viewBox="0 0 10 10" width="8" height="8" fill="none"><path d="M1 1L9 9M9 1L1 9" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg></span>');
        slot.appendChild(thumbBtn);

        var label = document.createElement('span');
        label.className = 'endro-pd-recap-thumb-label';
        label.textContent = product.name || '';
        slot.appendChild(label);

        slotsEl.appendChild(slot);
      }
    }

    var priceWrap = document.querySelector('[data-recap-price]');
    var priceOld = document.querySelector('[data-recap-price-old]');
    var priceNew = document.querySelector('[data-recap-price-new]');
    var ctaPrice = document.querySelector('[data-recap-cta-price]');
    var ctaDivider = document.querySelector('[data-recap-cta-divider]');
    var originalTotal = state.selected.reduce(function (sum, sid) {
      var p = d.products[sid];
      return sum + (p && p.price ? p.price : 0);
    }, 0);
    var finalPrice = (d.totalPrice || 1990) / 100;
    if (state.selected.length > 0) {
      if (priceWrap) priceWrap.hidden = false;
      if (priceOld) priceOld.textContent = formatEuro(originalTotal);
      if (priceNew) priceNew.textContent = formatEuro(finalPrice);
      if (ctaPrice) {
        ctaPrice.hidden = false;
        ctaPrice.innerHTML = '<span class="endro-pd-recap-cta-price-old">' + formatEuro(originalTotal) + '</span><span>' + formatEuro(finalPrice) + '</span>';
      }
      if (ctaDivider) ctaDivider.hidden = false;
    } else {
      if (priceWrap) priceWrap.hidden = true;
      if (ctaPrice) { ctaPrice.hidden = true; ctaPrice.innerHTML = ''; }
      if (ctaDivider) ctaDivider.hidden = true;
    }

    // Compteur des palettes deja au panier, et invitation a en composer une
    // autre tant que le plafond de la reduction n'est pas atteint.
    var lab = d.labels || {};
    var doneEl = document.querySelector('[data-recap-done]');
    if (doneEl) {
      doneEl.hidden = state.palettes.length === 0;
      doneEl.textContent = state.palettes.length === 1
        ? (lab.paletteAuPanierSingulier || '1 palette au panier')
        : (lab.palettesAuPanier || '{count} palettes au panier').replace('{count}', String(state.palettes.length));
    }
    var nextBtn = document.querySelector('[data-recap-next]');
    if (nextBtn) {
      var peut = peutComposerSuivante();
      var plafond = isComplete() && state.cartSynced && nbPalettes() >= maxPalettes();
      nextBtn.hidden = !peut && !plafond;
      nextBtn.disabled = !peut;
      nextBtn.textContent = peut
        ? (lab.composerSuivante || 'Composer une autre palette')
        : (lab.maxAtteint || 'Maximum atteint');
    }

    var progressbar = document.querySelector('[data-recap-progressbar]');
    if (progressbar) progressbar.setAttribute('aria-valuenow', state.selected.length);

    var cta = document.querySelector('[data-recap-cta]');
    var ctaLabel = document.querySelector('[data-recap-cta-label]');
    if (cta) {
      cta.disabled = !!state.submitting || (!complete && isConfiguratorInView);
      if (ctaLabel) {
        ctaLabel.textContent = state.submitting
          ? ((d.labels && d.labels.addingInProgress) || 'Ajout en cours...')
          : (complete && state.cartSynced)
            ? ((d.labels && d.labels.viewCart) || 'Voir mon panier')
            : ((!isConfiguratorInView && !complete) ? (d.ctaLabelSticky || 'Composer ma palette') : ((d.labels && d.labels.addToCart) || 'Ajouter au panier'));
      }
    }

    renderDrawer();
  }

  function renderDrawer() {
    if (!state.openDrawerId) return;
    var d = getData();
    var product = d.products[state.openDrawerId];
    if (!product) return;

    var selected = isSelected(product.id);
    var complete = isComplete();
    var blocked = product.soldOut || (complete && !selected);

    var drawer = document.querySelector('[data-endro-drawer]');
    if (!drawer) return;

    drawer.querySelector('[data-endro-drawer-img]').src = product.drawerImage || product.image;
    drawer.querySelector('[data-endro-drawer-img]').alt = product.imageAlt || '';

    var gammeBadge = drawer.querySelector('[data-endro-drawer-gamme]');
    gammeBadge.textContent = product.gammeLabel || '';
    gammeBadge.style.background = GAMME_COLORS[product.gamme] || '#000';

    drawer.querySelector('[data-endro-drawer-soldout]').hidden = !product.soldOut;

    drawer.querySelector('[data-endro-drawer-contenance]').textContent = product.contenance || '';
    drawer.querySelector('[data-endro-drawer-name]').textContent = product.name || '';
    drawer.querySelector('[data-endro-drawer-price]').textContent = formatEuro(product.price || 0);
    drawer.querySelector('[data-endro-drawer-description]').textContent = product.description || '';
    drawer.querySelector('[data-endro-drawer-benefit]').textContent = product.benefit || '';
    drawer.querySelector('[data-endro-drawer-idealfor]').textContent = product.idealFor || '';
    drawer.querySelector('[data-endro-drawer-keyingredient]').textContent = product.keyIngredient || '';

    var concernRow = drawer.querySelector('[data-endro-drawer-concern-row]');
    if (product.concern) {
      concernRow.hidden = false;
      drawer.querySelector('[data-endro-drawer-concern]').textContent = product.concern;
    } else {
      concernRow.hidden = true;
    }

    drawer.querySelector('[data-endro-drawer-stars]').innerHTML = buildStarsSvg(product.rating || 0, 'pd-drawer-star-' + product.id);
    drawer.querySelector('[data-endro-drawer-reviewcount]').textContent = (product.reviewCount || 0).toLocaleString('fr-FR') + ' ' + ((d.labels && d.labels.reviewsSuffix) || 'Avis');
    drawer.querySelector('[data-endro-drawer-pdp-link]').href = 'https://endro-cosmetiques.com/products/' + product.id;

    var ctaBtn = drawer.querySelector('[data-endro-drawer-cta]');
    ctaBtn.disabled = blocked;
    ctaBtn.classList.toggle('is-selected', selected);
    ctaBtn.textContent = selected ? ((d.labels && d.labels.addedRemove) || 'Ajouté, retirer') : ((d.labels && d.labels.addToPalette) || 'Ajouter à ma palette');
  }

  function openDrawer(id) {
    var d = getData();
    if (!d.products[id]) return;
    state.openDrawerId = id;
    document.querySelector('[data-endro-drawer-overlay]').hidden = false;
    document.querySelector('[data-endro-drawer]').hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      document.querySelector('[data-endro-drawer-overlay]').classList.add('is-open');
      document.querySelector('[data-endro-drawer]').classList.add('is-open');
    });
    renderDrawer();
  }

  function closeDrawer() {
    if (!state.openDrawerId) return;
    state.openDrawerId = null;
    document.body.style.overflow = '';
    var overlay = document.querySelector('[data-endro-drawer-overlay]');
    var drawer = document.querySelector('[data-endro-drawer]');
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    setTimeout(function () {
      if (!state.openDrawerId) { overlay.hidden = true; drawer.hidden = true; }
    }, 350);
  }

  function submitClassicCartForm(items) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    items.forEach(function (p) {
      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id[]';
      idInput.value = p.variantId;
      form.appendChild(idInput);

      var qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity[]';
      qtyInput.value = '1';
      form.appendChild(qtyInput);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function addProductsToCart() {
    var d = getData();
    if (state.selected.length !== d.selectionSize) {
      console.error('[BC] Ajout bloqué : ' + state.selected.length + '/' + d.selectionSize + ' produits sélectionnés');
      return;
    }

    // Les 6 produits ont déjà été réellement ajoutés au panier Shopify lors de
    // l'auto-ouverture du drawer (6e produit sélectionné, cf. syncCartAndOpenDrawer)
    // — on évite un double ajout et on va directement au panier.
    // Le panier est deja a jour : on rouvre le drawer du theme plutot que de
    // quitter la page. Indispensable depuis qu'on masque l'en-tete du site :
    // sans icone panier, c'est le seul moyen de revenir au panier une fois le
    // drawer ferme.
    if (state.cartSynced) {
      openThemeCartDrawer();
      return;
    }

    var items = state.selected.map(function (id) { return d.products[id]; });

    state.submitting = true;
    render();

    synchroniserLePanier().then(function () {
      window.location.href = '/cart';
    }).catch(function (err) {
      console.error('[BC] Failed to add products to cart:', err);
      state.submitting = false;
      render();
      submitClassicCartForm(items);
    });
  }

  var gammesScroll = document.querySelector('[data-endro-gammes-scroll]');
  function scrollGammesBy(direction) {
    if (!gammesScroll) return;
    var card = gammesScroll.querySelector('a');
    var width = card ? card.getBoundingClientRect().width : 280;
    gammesScroll.scrollBy({ left: direction === 'left' ? -(width + 16) : (width + 16), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var scrollBtn = e.target.closest('[data-endro-scroll-to]');
    if (scrollBtn) {
      e.preventDefault();
      var target = document.getElementById(scrollBtn.getAttribute('data-endro-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var gammesPrevBtn = e.target.closest('[data-endro-gammes-prev]');
    if (gammesPrevBtn) { scrollGammesBy('left'); return; }

    var gammesNextBtn = e.target.closest('[data-endro-gammes-next]');
    if (gammesNextBtn) { scrollGammesBy('right'); return; }

    var faqToggleBtn = e.target.closest('[data-endro-faq-toggle]');
    if (faqToggleBtn) {
      var faqItem = faqToggleBtn.closest('.endro-pd-faq-item');
      var wasOpen = faqItem.classList.contains('is-open');
      document.querySelectorAll('.endro-pd-faq-item').forEach(function (el) {
        el.classList.remove('is-open');
        var btn = el.querySelector('[data-endro-faq-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        faqItem.classList.add('is-open');
        faqToggleBtn.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var filterBtn = e.target.closest('[data-endro-filter]');
    if (filterBtn) {
      var newType = filterBtn.getAttribute('data-endro-filter');
      state.activeType = (state.activeType === newType || !newType) ? '' : newType;
      applyFilter();
      return;
    }

    var toggleBtn = e.target.closest('[data-endro-toggle]');
    if (toggleBtn && !toggleBtn.disabled) { toggle(toggleBtn.getAttribute('data-endro-toggle')); return; }

    var chipRemove = e.target.closest('[data-recap-remove]');
    if (chipRemove) { toggle(chipRemove.getAttribute('data-recap-remove')); return; }

    var giftPopupClose = e.target.closest('[data-recap-gift-popup-close]');
    if (giftPopupClose) {
      var giftPopupEl = document.querySelector('[data-recap-gift-popup]');
      if (giftPopupEl) { giftPopupEl.hidden = true; clearTimeout(state.giftPopupTimer); }
      return;
    }

    var videoPlayBtn = e.target.closest('[data-endro-video-play]');
    if (videoPlayBtn) {
      var videoFrame = videoPlayBtn.closest('[data-endro-video-frame]');
      if (videoFrame) {
        videoFrame.innerHTML = '<iframe width="560" height="315" src="https://www.youtube.com/embed/p6bwH9YW4zc?si=lEDqaJVW1g0SZhA4&playsinline=1&rel=0&modestbranding=1&autoplay=1" title="' + ((getData().labels && getData().labels.videoTitle) || 'Palette découverte') + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
      }
      return;
    }

    var inviteBtn = e.target.closest('[data-recap-invite], [data-recap-goto]');
    if (inviteBtn) {
      var configuratorSection2 = document.getElementById('configurateur');
      if (configuratorSection2) configuratorSection2.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    var suivanteBtn = e.target.closest('[data-endro-action="palette-suivante"]');
    if (suivanteBtn) { composerPaletteSuivante(); return; }

    var cta = e.target.closest('[data-endro-action="add-to-cart"]');
    if (cta && !cta.disabled) {
      if (isComplete()) {
        addProductsToCart();
      } else {
        var configuratorSection = document.getElementById('configurateur');
        if (configuratorSection) configuratorSection.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    var infoBtn = e.target.closest('[data-endro-info]');
    if (infoBtn) { openDrawer(infoBtn.getAttribute('data-endro-info')); return; }

    // Clic n'importe ou sur la carte, image comprise. On delegue au bouton de la
    // carte plutot que d'appeler toggle() directement : ses regles (rupture de
    // stock, palette deja pleine) restent la seule source de verite.
    var cardEl = e.target.closest('[data-endro-card]');
    if (cardEl) {
      var cardBtn = cardEl.querySelector('[data-endro-toggle]');
      if (cardBtn && !cardBtn.disabled) { toggle(cardBtn.getAttribute('data-endro-toggle')); }
      return;
    }

    var drawerClose = e.target.closest('[data-endro-drawer-close]');
    if (drawerClose) { closeDrawer(); return; }

    var drawerOverlay = e.target.closest('[data-endro-drawer-overlay]');
    if (drawerOverlay) { closeDrawer(); return; }

    var drawerCta = e.target.closest('[data-endro-drawer-cta]');
    if (drawerCta && !drawerCta.disabled && state.openDrawerId) { toggle(state.openDrawerId); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.openDrawerId) closeDrawer();
  });

  var eecCells = document.querySelectorAll('[data-eec-val]');
  function animateEecCell(cell) {
    cell.classList.add('is-in');
    var isStatic = cell.getAttribute('data-eec-static') === 'true';
    var numEl = cell.querySelector('[data-eec-num]');
    if (isStatic || !numEl) return;
    var to = parseInt(cell.getAttribute('data-eec-val'), 10) || 0;
    var prefix = cell.getAttribute('data-eec-prefix') || '';
    var suffix = cell.getAttribute('data-eec-suffix') || '';
    var duration = 1400;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      numEl.textContent = prefix + Math.round(eased * to).toLocaleString('fr-FR') + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if (eecCells.length && 'IntersectionObserver' in window) {
    var eecObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateEecCell(entry.target);
          eecObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    eecCells.forEach(function (cell) { eecObserver.observe(cell); });
  } else {
    eecCells.forEach(animateEecCell);
  }

  var stepsWrap = document.querySelector('[data-endro-steps]');
  var STEP_DURATION = 4600;
  var STEP_FILL_DURATION = 2800;
  var STEP_EASING = 'cubic-bezier(0.65,0,0.35,1)';
  var stepDots = stepsWrap ? Array.prototype.slice.call(stepsWrap.querySelectorAll('[data-endro-dot]')) : [];
  var stepFills = stepsWrap ? Array.prototype.slice.call(stepsWrap.querySelectorAll('[data-endro-fill]')) : [];
  var stepCards = stepsWrap ? Array.prototype.slice.call(stepsWrap.querySelectorAll('.endro-pd-step')) : [];
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function applyActiveStep(active) {
    stepDots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === active);
      dot.classList.toggle('is-done', i < active);
    });
    stepFills.forEach(function (fill, i) {
      if (i < active) {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(1)';
      } else if (i === active) {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(0)';
        void fill.offsetWidth;
        fill.style.transition = 'transform ' + STEP_FILL_DURATION + 'ms ' + STEP_EASING;
        fill.style.transform = 'scaleX(1)';
      } else {
        fill.style.transition = 'none';
        fill.style.transform = 'scaleX(0)';
      }
    });
    stepCards.forEach(function (card, i) {
      card.classList.toggle('is-active', i === active);
    });
  }

  function startStepCycle() {
    if (reducedMotion || !stepCards.length) return;
    var active = 0;
    applyActiveStep(active);
    setInterval(function () {
      active = (active + 1) % stepCards.length;
      applyActiveStep(active);
    }, STEP_DURATION);
  }

  if (stepsWrap && 'IntersectionObserver' in window) {
    var stepsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stepsWrap.classList.add('is-in-view');
          startStepCycle();
          stepsObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    stepsObserver.observe(stepsWrap);
  } else if (stepsWrap) {
    stepsWrap.classList.add('is-in-view');
    startStepCycle();
  }

  var configuratorSectionEl = document.getElementById('configurateur');
  if (configuratorSectionEl && 'IntersectionObserver' in window) {
    var configuratorObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        isConfiguratorInView = entry.isIntersecting;
        render();
      });
    }, { threshold: 0 });
    configuratorObserver.observe(configuratorSectionEl);
  }

  // ── Reconciliation avec le panier reel ───────────────────────────────────
  // La cliente peut retirer des lignes ou changer une quantite depuis le drawer
  // du theme, que la LP ne controle pas. On relit le panier et on realigne :
  //   - la ligne Palette a disparu -> plus rien ne justifie des minis a 0 EUR,
  //     on vide tout ;
  //   - une palette validee a perdu un soin -> elle n'a plus six soins, on la
  //     retire en entier plutot que de facturer 19,90 EUR pour moins ;
  //   - la quantite de la ligne Palette a baisse -> on abandonne les dernieres
  //     palettes composees pour retomber sur ce que la cliente demande.
  // Dans tous les cas on ne touche qu'aux lignes de la LP : les autres produits
  // qu'elle a ajoutes restent au panier.
  function reconcilierAvecLePanier() {
    var d = getData();
    if (!state.selected.length && !state.palettes.length) return;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var qte = {};
        cart.items.forEach(function (it) { qte[String(it.variant_id)] = it.quantity; });
        var idPalette = d.paletteVariantId ? String(d.paletteVariantId) : null;
        var qtePalette = idPalette ? (qte[idPalette] || 0) : 0;
        // Les quantites du panier sont consommees palette par palette, de la plus
        // ancienne a la plus recente. Un soin present en un seul exemplaire alors
        // que deux palettes le reclament n'est honore que pour la premiere : depuis
        // qu'un meme soin peut figurer dans les deux, tester la simple presence ne
        // suffit plus.
        var reste = {};
        Object.keys(qte).forEach(function (v) { reste[v] = qte[v]; });
        var prendre = function (id) {
          var p = d.products[id];
          if (!p) return false;
          var v = String(p.variantId);
          if ((reste[v] || 0) <= 0) return false;
          reste[v] -= 1;
          return true;
        };

        if (idPalette && state.cartSynced && qtePalette === 0) {
          state.palettes = [];
          state.selected = [];
          state.hasAutoOpenedCartDrawer = false;
          render();
          return synchroniserLePanier().then(rafraichirPanier);
        }

        var avantPalettes = state.palettes.length;
        var avantSelection = state.selected.length;
        var retenues = [];
        state.palettes.forEach(function (pal) {
          var avant = {};
          Object.keys(reste).forEach(function (v) { avant[v] = reste[v]; });
          if (pal.every(prendre)) retenues.push(pal); else reste = avant;
        });
        state.palettes = retenues;
        state.selected = state.selected.filter(prendre);

        // Elle a baisse la quantite de la ligne Palette : on abandonne les
        // palettes les plus recentes d'abord, celle qu'elle vient de composer
        // avant celles d'avant.
        if (idPalette && qtePalette > 0 && qtePalette < nbPalettes()) {
          var trop = nbPalettes() - qtePalette;
          if (trop > 0 && isComplete()) { state.selected = []; trop--; }
          while (trop > 0 && state.palettes.length) { state.palettes.pop(); trop--; }
        }

        var change = avantPalettes !== state.palettes.length
          || avantSelection !== state.selected.length
          || (idPalette && qtePalette !== nbPalettes());
        if (!change) return;
        state.hasAutoOpenedCartDrawer = isComplete();
        render();
        return synchroniserLePanier().then(rafraichirPanier);
      })
      .catch(function () { /* panier injoignable : on ne touche a rien */ });
  }

  // Le drawer du theme vit sur la meme page : un clic sur « Supprimer » ou un
  // changement de quantite ne declenche aucun evenement que la LP recevrait.
  // On se raccroche donc aux controles du thème, puis on relit le panier.
  var minuteurReconciliation = null;
  function planifierReconciliation() {
    clearTimeout(minuteurReconciliation);
    minuteurReconciliation = setTimeout(reconcilierAvecLePanier, 700);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-remove-line], cart-drawer [data-remove-line]')) planifierReconciliation();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest('.quantity-input')) planifierReconciliation();
  }, true);
  // Retour depuis la page /cart ou depuis un autre onglet.
  window.addEventListener('focus', reconcilierAvecLePanier);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reconcilierAvecLePanier();
  });

  // Video decorative : on la met en pause si la personne a demande a limiter les
  // animations. L'affiche reste visible et le hero garde tout son sens.
  var heroVideo = document.querySelector('[data-endro-hero-video]');
  if (heroVideo && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    heroVideo.removeAttribute('autoplay');
    heroVideo.pause();
  }

  render();
  rehydraterDepuisLePanier();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-lp-set-deodorants"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function formatEuro(n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function scrollToConfig() { var el = document.getElementById('configurateur'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  var SET_SIZE = 5, FREE_SHIPPING_THRESHOLD = 49, FREE_MASK_THRESHOLD = 59, PER_PRODUCT_MAX = 10;
  var GIFT_POS = 30, TRUCK_POS = 60, MASK_POS = 92;

  // Ruptures de stock : source unique = window.ENDRO_V3.products[id].available (injecté par Liquid
  // depuis inventory_quantity Shopify). Plus de liste hardcodée à maintenir manuellement.
  function isSoldOut(id) { var d = getData(); return d.products[id] ? d.products[id].available === false : false; }
  function soldOutUrl(id) { var d = getData(); return (d.products[id] && d.products[id].url) || '#'; }

  // Le cadeau 4+1 est toujours disponible : c'est le 5e déo sélectionné par l'utilisateur
  // qui est offert (pas un produit physique séparé). Si les items sont en stock, le cadeau l'est.

  function getData() { return window.ENDRO_V3 || { products: {}, order: [], meta: {} }; }

  var state = { selection: {}, showDetails: false, openDrawer: null };

  function totalCount() { var n = 0; for (var k in state.selection) n += state.selection[k]; return n; }
  function selectedItems() {
    var items = []; var d = getData(); var keys = d.order || [];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]; var qty = state.selection[key] || 0;
      for (var j = 0; j < qty; j++) items.push(d.products[key]);
    }
    return items;
  }
  function findGiftIndex(items) {
    if (items.length < SET_SIZE) return -1;
    var min = 0;
    for (var i = 1; i < items.length; i++) if (items[i].price < items[min].price) min = i;
    return min;
  }
  function compute() {
    var items = selectedItems();
    var total = items.reduce(function (s, p) { return s + p.price; }, 0);
    var giftIndex = findGiftIndex(items);
    var giftPrice = giftIndex >= 0 ? items[giftIndex].price : 0;
    var finalPrice = Math.max(0, total - giftPrice);
    var count = totalCount();
    return { items: items, count: count, hasItems: count > 0, qualifiesForGift: count >= SET_SIZE, remainingForGift: Math.max(0, SET_SIZE - count), total: total, giftIndex: giftIndex, giftPrice: giftPrice, finalPrice: finalPrice, hasFreeShipping: finalPrice >= FREE_SHIPPING_THRESHOLD, amountToFreeShipping: Math.max(0, FREE_SHIPPING_THRESHOLD - finalPrice), hasFreeMask: finalPrice >= FREE_MASK_THRESHOLD, amountToFreeMask: Math.max(0, FREE_MASK_THRESHOLD - finalPrice), giftPercent: Math.min(100, (count / SET_SIZE) * 100), shippingPercent: Math.min(100, (finalPrice / FREE_SHIPPING_THRESHOLD) * 100), maskPercent: Math.min(100, Math.max(0, ((finalPrice - FREE_SHIPPING_THRESHOLD) / (FREE_MASK_THRESHOLD - FREE_SHIPPING_THRESHOLD)) * 100)) };
  }
  function increment(id) {
    if (isSoldOut(id)) { console.warn('[Endro] Produit en rupture de stock :', id); return; }
    var pd = getData().products[id];
    if (!pd || !parseInt(pd.variantId, 10)) { console.warn('[Endro] Produit non disponible (non résolu) :', id); return; }
    if (pd.available === false) { console.warn('[Endro] Produit en rupture de stock :', id); return; }
    var c = state.selection[id] || 0; if (c >= PER_PRODUCT_MAX) return; state.selection[id] = c + 1; render();
  }
  function decrement(id) { var c = state.selection[id] || 0; if (c <= 0) return; state.selection[id] = c - 1; if (state.selection[id] === 0) delete state.selection[id]; render(); }
  function reset() { state.selection = {}; state.showDetails = false; render(); }
  // Retire les SKU en rupture d'un preset pour ne jamais pré-sélectionner un produit indisponible.
  function cleanPreset(sel) { var out = {}; for (var k in sel) { if (!isSoldOut(k)) out[k] = sel[k]; } return out; }
  function presetDecouverte() { state.selection = cleanPreset({ 'rose-full': 1, 'vegetal-full': 1, 'soleil-full': 1, 'proage-full': 1, 'rose-recharge': 1 }); render(); }
  function presetPeauxSensibles() { state.selection = cleanPreset({ 'rose-full': 2, 'rose-recharge': 1, 'proage-full': 1, 'proage-recharge': 1 }); render(); }
  function selectionEquals(a, b) {
    var ak = Object.keys(a).filter(function (k) { return a[k] > 0; });
    var bk = Object.keys(b);
    if (ak.length !== bk.length) return false;
    for (var i = 0; i < bk.length; i++) if (a[bk[i]] !== b[bk[i]]) return false;
    return true;
  }

  // Passe une ligne format en état "rupture de stock" : masque le bouton +Ajouter / les
  // contrôles qté, et injecte (une seule fois) un badge "Rupture de stock".
  function applySoldOut(row, addBtn, qtyControls, id) {
    row.classList.remove('is-active');
    row.classList.add('is-soldout');
    if (addBtn) addBtn.hidden = true;
    if (qtyControls) qtyControls.hidden = true;
    var action = row.querySelector('.endro-v3-format-action');
    if (action && !action.querySelector('[data-endro-soldout]')) {
      // Produit en rupture : "Me prévenir" → fiche produit (formulaire retour en stock), nouvel onglet.
      var link = document.createElement('a');
      link.className = 'endro-btn-secondary endro-v3-tinybtn endro-v3-prevenir-btn';
      link.setAttribute('data-endro-soldout', '');
      link.href = soldOutUrl(id);
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Me prévenir';
      action.appendChild(link);
    }
  }
  // Annule l'état "rupture" sur une ligne (le drawer réutilise les mêmes lignes pour tous les parfums).
  function clearSoldOut(row) {
    row.classList.remove('is-soldout');
    var badge = row.querySelector('[data-endro-soldout]');
    if (badge) badge.remove();
  }

  function renderCards() {
    var d = getData();
    document.querySelectorAll('[data-endro-card]').forEach(function (card) {
      var parfum = card.getAttribute('data-endro-card');
      var stickQty = state.selection[parfum + '-full'] || 0;
      var rechargeQty = state.selection[parfum + '-recharge'] || 0;
      var total = stickQty + rechargeQty;
      var selected = total > 0;
      card.classList.toggle('is-selected', selected);
      var qtyBadge = card.querySelector('[data-endro-card-qty]');
      if (qtyBadge) { qtyBadge.textContent = total; qtyBadge.hidden = !selected; }
    });
    document.querySelectorAll('[data-endro-format-row]').forEach(function (row) {
      var id = row.getAttribute('data-endro-product');
      var addBtn = row.querySelector('[data-endro-add]');
      var qtyControls = row.querySelector('[data-endro-qty-controls]');
      if (isSoldOut(id)) { applySoldOut(row, addBtn, qtyControls, id); return; }
      var qty = state.selection[id] || 0;
      var selected = qty > 0;
      row.classList.toggle('is-active', selected);
      if (addBtn && qtyControls) {
        if (selected) {
          addBtn.hidden = true; qtyControls.hidden = false;
          var label = qtyControls.querySelector('[data-endro-qty-label]');
          if (label) label.textContent = qty;
        } else {
          addBtn.hidden = false; qtyControls.hidden = true;
        }
      }
    });
    // Presets désactivés (produits en rupture) — boutons grisés, non sélectionnables.
  }

  function renderRecapBar() {
    var bar = document.querySelector('[data-endro-recap-bar]');
    if (!bar) return;
    var c = compute();
    var d = getData();

    var emptyToggle = bar.querySelector('[data-recap-empty]');
    var fullToggle = bar.querySelector('[data-recap-full]');
    if (emptyToggle && fullToggle) {
      emptyToggle.hidden = c.hasItems;
      fullToggle.hidden = !c.hasItems;
    }

    // Avatars
    var avatars = bar.querySelector('[data-recap-avatars]');
    if (avatars) {
      avatars.innerHTML = '';
      var parfumsInSet = [];
      Object.keys(d.meta).forEach(function (p) {
        var stickQ = state.selection[p + '-full'] || 0;
        var rechargeQ = state.selection[p + '-recharge'] || 0;
        if (stickQ + rechargeQ > 0) parfumsInSet.push(p);
      });
      parfumsInSet.slice(0, 4).forEach(function (p) {
        var span = document.createElement('span');
        var mp = d.meta[p] || {};
        var thumb = mp.thumbImage || mp.colImage;
        if (thumb) {
          span.style.background = mp.color || '#e8e8e8';
          var im = document.createElement('img');
          im.src = thumb; im.alt = ''; im.loading = 'lazy';
          span.appendChild(im);
        } else {
          span.style.background = mp.color;
        }
        avatars.appendChild(span);
      });
    }

    var countSub = bar.querySelector('[data-recap-count-sub]');
    if (countSub) countSub.textContent = c.count + ' produit' + (c.count > 1 ? 's' : '');

    var toggleLabel = bar.querySelector('[data-recap-toggle-label]');
    if (toggleLabel) toggleLabel.textContent = state.showDetails ? 'Masquer mon set' : 'Voir mon set';
    if (fullToggle) fullToggle.classList.toggle('is-expanded', state.showDetails);

    // Progress
    var fill = bar.querySelector('[data-endro-progress-fill]');
    var fillPct;
    if (c.hasFreeMask) fillPct = 100;
    else if (c.hasFreeShipping) fillPct = TRUCK_POS + (c.maskPercent / 100) * (MASK_POS - TRUCK_POS);
    else if (c.qualifiesForGift) fillPct = GIFT_POS + (c.shippingPercent / 100) * (TRUCK_POS - GIFT_POS);
    else fillPct = (c.giftPercent / 100) * GIFT_POS;
    if (fill) fill.style.width = fillPct + '%';

    var markerGift = bar.querySelector('[data-marker-gift]');
    var markerTruck = bar.querySelector('[data-marker-truck]');
    var markerMask = bar.querySelector('[data-marker-mask]');
    if (markerGift) { markerGift.classList.toggle('is-done', c.qualifiesForGift); markerGift.classList.remove('is-soldout'); }
    if (markerTruck) markerTruck.classList.toggle('is-done', c.hasFreeShipping);
    if (markerMask) markerMask.classList.toggle('is-done', c.hasFreeMask);

    var labelGift = bar.querySelector('[data-label-gift]');
    var labelGiftSub = bar.querySelector('[data-label-gift-sub]');
    var labelTruck = bar.querySelector('[data-label-truck]');
    var labelTruckSub = bar.querySelector('[data-label-truck-sub]');
    var labelMask = bar.querySelector('[data-label-mask]');
    var labelMaskSub = bar.querySelector('[data-label-mask-sub]');
    if (labelGift) { labelGift.classList.toggle('is-done', c.qualifiesForGift); labelGift.classList.remove('is-soldout'); }
    if (labelTruck) labelTruck.classList.toggle('is-done', c.hasFreeShipping);
    if (labelMask) labelMask.classList.toggle('is-done', c.hasFreeMask);
    if (labelGiftSub) {
      labelGiftSub.textContent = c.qualifiesForGift ? '✓ débloqué' : c.remainingForGift + ' produit' + (c.remainingForGift > 1 ? 's' : '') + ' restant' + (c.remainingForGift > 1 ? 's' : '');
    }
    if (labelTruckSub) labelTruckSub.textContent = c.hasFreeShipping ? '✓ débloquée' : "dès " + FREE_SHIPPING_THRESHOLD + " € d'achat";
    if (labelMaskSub) labelMaskSub.textContent = c.hasFreeMask ? '✓ débloquée' : "à partir de " + FREE_MASK_THRESHOLD + " €";

    var total = bar.querySelector('[data-recap-total]');
    if (total) total.textContent = formatEuro(c.finalPrice);

    var cta = bar.querySelector('[data-recap-cta]');
    if (cta) {
      cta.textContent = c.hasItems ? 'Ajouter au panier · ' + formatEuro(c.finalPrice) + ' →' : 'Choisissez vos produits ↑';
    }

    // Details panel
    var details = bar.querySelector('[data-endro-recap-details]');
    if (details) details.classList.toggle('is-open', state.showDetails && c.hasItems);
    var detailsCount = bar.querySelector('[data-recap-details-count]');
    if (detailsCount) detailsCount.textContent = c.count + ' produit' + (c.count > 1 ? 's' : '');

    var items = bar.querySelector('[data-endro-recap-items]');
    if (items) {
      items.innerHTML = '';
      var giftItem = (c.giftIndex >= 0 && c.items[c.giftIndex]) ? c.items[c.giftIndex] : null;
      Object.keys(d.meta).forEach(function (parfum) {
        var stickQ = state.selection[parfum + '-full'] || 0;
        var rechargeQ = state.selection[parfum + '-recharge'] || 0;
        if (stickQ + rechargeQ === 0) return;
        var meta = d.meta[parfum];
        var stickP = d.products[parfum + '-full'] ? d.products[parfum + '-full'].price : 0;
        var rechargeP = d.products[parfum + '-recharge'] ? d.products[parfum + '-recharge'].price : 0;
        var totalP = stickP * stickQ + rechargeP * rechargeQ;
        var parts = [];
        if (stickQ > 0) parts.push(stickQ + ' stick' + (stickQ > 1 ? 's' : ''));
        if (rechargeQ > 0) parts.push(rechargeQ + ' recharge' + (rechargeQ > 1 ? 's' : ''));
        var li = document.createElement('li');
        var thumbHtml = meta.thumbImage
          ? '<span class="endro-v3-recap-thumb-img" style="background:' + meta.color + '22"><img src="' + meta.thumbImage + '" alt="" loading="lazy"></span>'
          : '<span class="endro-v3-recap-color-bar" style="background:' + meta.color + '"></span>';
        var giftTag = '';
        if (giftItem && giftItem.parfum === parfum) {
          giftTag = ' <span class="endro-v3-recap-gift-tag">🎁 ' + (giftItem.format === 'full' ? 'STICK OFFERT' : 'RECHARGE OFFERTE') + '</span>';
        }
        li.innerHTML = thumbHtml +
          '<span style="flex:1; min-width:0;"><strong>' + meta.name + '</strong> · <span style="opacity:0.6">' + parts.join(' + ') + '</span>' + giftTag + '</span>' +
          '<span style="font-weight:700; color:var(--color-brand-deep); white-space:nowrap;">' + formatEuro(totalP) + '</span>';
        items.appendChild(li);
      });
    }
  }

  function renderDrawer() {
    var drawer = document.querySelector('[data-endro-drawer]');
    var overlay = document.querySelector('[data-endro-drawer-overlay]');
    if (!drawer || !overlay) return;
    var p = state.openDrawer;
    drawer.hidden = !p;
    overlay.hidden = !p;
    if (!p) { document.body.style.overflow = ''; return; }
    document.body.style.overflow = 'hidden';
    var d = getData();
    var meta = d.meta[p];
    if (!meta) return;
    var img = drawer.querySelector('[data-drawer-img]');
    var badge = drawer.querySelector('[data-drawer-badge]');
    var name = drawer.querySelector('[data-drawer-name]');
    var note = drawer.querySelector('[data-drawer-note]');
    var desc = drawer.querySelector('[data-drawer-desc]');
    var matiere = drawer.querySelector('[data-drawer-matiere]');
    var pourqui = drawer.querySelector('[data-drawer-pourqui]');
    if (img && meta.ingImage) img.src = meta.ingImage;
    if (badge) {
      badge.textContent = meta.badge || '';
      badge.className = 'endro-v3-card-badge ' + (p === 'rose' ? 'is-bestseller' : 'is-new');
    }
    if (name) { name.textContent = meta.name; name.style.color = meta.color; }
    if (note) note.textContent = meta.note;
    if (desc) desc.textContent = meta.description;
    if (matiere) matiere.textContent = meta.matiere;
    if (pourqui) pourqui.textContent = meta.pourqui;
    var heroBg = drawer.querySelector('[data-drawer-hero]');
    if (heroBg) heroBg.style.background = meta.color + '1A';

    var stickQty = state.selection[p + '-full'] || 0;
    var rechargeQty = state.selection[p + '-recharge'] || 0;
    var stickProd = d.products[p + '-full'];
    var rechargeProd = d.products[p + '-recharge'];
    var stickP = stickProd ? stickProd.price : 0;
    var rechargeP = rechargeProd ? rechargeProd.price : 0;
    var stickAvail = stickProd ? stickProd.available !== false : true;
    var rechargeAvail = rechargeProd ? rechargeProd.available !== false : true;
    var stickUrl = stickProd && stickProd.url ? stickProd.url : '/collections/deodorants';
    var rechargeUrl = rechargeProd && rechargeProd.url ? rechargeProd.url : '/collections/deodorants';
    var stickPriceEl = drawer.querySelector('[data-drawer-stick-price]');
    var rechargePriceEl = drawer.querySelector('[data-drawer-recharge-price]');
    if (stickPriceEl) stickPriceEl.textContent = formatEuro(stickP);
    if (rechargePriceEl) rechargePriceEl.textContent = formatEuro(rechargeP);

    var stickRow = drawer.querySelector('[data-drawer-stick-row]');
    var rechargeRow = drawer.querySelector('[data-drawer-recharge-row]');
    [
      { row: stickRow, qty: stickQty, color: meta.color, avail: stickAvail, url: stickUrl, soldoutSel: '[data-drawer-stick-soldout]' },
      { row: rechargeRow, qty: rechargeQty, color: meta.color, avail: rechargeAvail, url: rechargeUrl, soldoutSel: '[data-drawer-recharge-soldout]' }
    ].forEach(function (cfg) {
      if (!cfg.row) return;
      cfg.row.classList.toggle('is-active', cfg.qty > 0);
      cfg.row.classList.toggle('is-soldout', !cfg.avail);
      cfg.row.style.setProperty('--card-accent', cfg.color);
      var addBtn = cfg.row.querySelector('[data-endro-add]');
      var qtyControls = cfg.row.querySelector('[data-endro-qty-controls]');
      var prevBtn = cfg.row.querySelector(cfg.soldoutSel);
      if (prevBtn) { prevBtn.href = cfg.url; prevBtn.hidden = cfg.avail; }
      if (!cfg.avail) {
        if (addBtn) addBtn.hidden = true;
        if (qtyControls) qtyControls.hidden = true;
      } else if (addBtn && qtyControls) {
        if (cfg.qty > 0) {
          addBtn.hidden = true; qtyControls.hidden = false;
          var lbl = qtyControls.querySelector('[data-endro-qty-label]');
          if (lbl) lbl.textContent = cfg.qty;
        } else {
          addBtn.hidden = false; qtyControls.hidden = true;
        }
      }
    });
  }

  function render() {
    renderCards();
    renderRecapBar();
    renderDrawer();
  }

  function addToCart() {
    var c = compute();
    if (!c.hasItems) { scrollToConfig(); return; }
    // Agrège par variantId. Filtre variantId 0 (produit non résolu — ex. Rose dépublié) : non envoyé.
    var grouped = {};
    c.items.forEach(function (p) {
      if (p && isSoldOut(p.id)) return; // garde-fou : jamais de SKU en rupture au panier
      var vid = p && parseInt(p.variantId, 10);
      if (!vid) return;
      grouped[vid] = (grouped[vid] || 0) + 1;
    });
    var lineItems = Object.keys(grouped).map(function (id) { return { id: parseInt(id, 10), quantity: grouped[id] }; });
    if (lineItems.length === 0) {
      console.warn('[Endro] Aucun produit avec variantId valide (Rose non résolu). Panier non envoyé.');
      scrollToConfig();
      return;
    }
    // Loading state CTA pendant l'appel + redirection (reset géré par pageshow au retour)
    var ctaBtn = document.querySelector('[data-recap-cta]');
    if (ctaBtn) { ctaBtn.classList.add('is-loading'); ctaBtn.disabled = true; ctaBtn.setAttribute('aria-busy', 'true'); }
    var d = getData();
    var code = (d && d.discountCode) ? d.discountCode : '';
    var afterAdd = code
      ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart')
      : '/cart';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function(j) { throw new Error(j.description || j.message || 'HTTP ' + res.status); });
      window.location.href = afterAdd;
    }).catch(function (err) {
      console.error('[Endro] /cart/add.js échec:', err);
      if (ctaBtn) { ctaBtn.classList.remove('is-loading'); ctaBtn.disabled = false; ctaBtn.removeAttribute('aria-busy'); }
      alert('Un produit de votre sélection n\'est plus disponible. Veuillez rafraîchir la page et réessayer.');
    });
  }
  // Reset CTA loading au retour (back button / bfcache)
  window.addEventListener('pageshow', function () {
    var ctaBtn = document.querySelector('[data-recap-cta]');
    if (ctaBtn) { ctaBtn.classList.remove('is-loading'); ctaBtn.disabled = false; ctaBtn.removeAttribute('aria-busy'); }
  });

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-endro-action]');
    if (!target) return;
    var action = target.getAttribute('data-endro-action');
    var id = target.getAttribute('data-endro-id');
    switch (action) {
      case 'scroll-to-config': e.preventDefault(); scrollToConfig(); break;
      case 'increment': if (id) increment(id); break;
      case 'decrement': if (id) decrement(id); break;
      case 'add': if (id) increment(id); break;
      case 'reset': reset(); break;
      case 'preset-decouverte': presetDecouverte(); break;
      case 'preset-peaux-sensibles': presetPeauxSensibles(); break;
      case 'add-to-cart': addToCart(); break;
      case 'toggle-recap': state.showDetails = !state.showDetails; render(); break;
      case 'open-drawer': if (id) { state.openDrawer = id; render(); } break;
      case 'close-drawer': state.openDrawer = null; render(); break;
      case 'drawer-add-stick': if (state.openDrawer) increment(state.openDrawer + '-full'); break;
      case 'drawer-decrement-stick': if (state.openDrawer) decrement(state.openDrawer + '-full'); break;
      case 'drawer-increment-stick': if (state.openDrawer) increment(state.openDrawer + '-full'); break;
      case 'drawer-add-recharge': if (state.openDrawer) increment(state.openDrawer + '-recharge'); break;
      case 'drawer-decrement-recharge': if (state.openDrawer) decrement(state.openDrawer + '-recharge'); break;
      case 'drawer-increment-recharge': if (state.openDrawer) increment(state.openDrawer + '-recharge'); break;
      case 'faq-toggle':
        var item = target.closest('[data-endro-faq-item]');
        if (item) {
          var open = item.getAttribute('data-open') === 'true';
          item.parentNode.querySelectorAll('[data-endro-faq-item]').forEach(function (it) {
            it.setAttribute('data-open', 'false');
            var btn = it.querySelector('[data-endro-action="faq-toggle"]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
          item.setAttribute('data-open', open ? 'false' : 'true');
          target.setAttribute('aria-expanded', open ? 'false' : 'true');
        }
        break;
    }
  });

  // Overlay click closes drawer
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-endro-drawer-overlay]')) {
      state.openDrawer = null;
      render();
    }
  });

  // Esc closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.openDrawer) {
      state.openDrawer = null;
      render();
    }
  });

  // Recap bar visibility (appears when user reaches configurator)
  function initRecapVisibility() {
    var section = document.getElementById('configurateur');
    var bar = document.querySelector('[data-endro-recap-bar]');
    if (!section || !bar) return;
    var trigger = section.querySelector('.endro-v3-cards') || section;
    var hasReached = false;
    function update() {
      if (hasReached) return;
      var rect = trigger.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.6) {
        hasReached = true;
        bar.classList.add('is-visible');
        document.body.style.paddingBottom = bar.offsetHeight + 'px';
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Naturellement — scroll-driven clip-path animation
  function initNaturellement() {
    var section = document.querySelector('[data-endro-naturellement]');
    if (!section) return;
    var sticky = section.querySelector('[data-endro-natu-sticky]');
    if (!sticky) return;
    var clipTargets = section.querySelectorAll('[data-endro-natu-clip]');
    var imgs = section.querySelectorAll('[data-endro-natu-img]');
    var contents = section.querySelectorAll('[data-endro-natu-content]');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function easeIn(t) { return t * t; }
    function update() {
      if (prefersReduced) { clipTargets.forEach(function (el) { el.style.clipPath = 'inset(0)'; }); imgs.forEach(function (i) { i.style.transform = 'none'; }); contents.forEach(function (c) { c.style.opacity = '1'; }); return; }
      var rect = section.getBoundingClientRect();
      var stickyH = sticky.getBoundingClientRect().height;
      var range = rect.height - stickyH;
      if (range <= 0) return;
      var p = Math.max(0, Math.min(1, -rect.top / range));
      var pE = easeIn(p), inv = 1 - pE;
      var clip = 'inset(' + (37 * inv) + '% ' + (37 * inv) + '% ' + (41 * inv) + '% ' + (37 * inv) + '%)';
      clipTargets.forEach(function (el) { el.style.clipPath = clip; });
      var tx = -10 * inv, ty = -1.5 * inv, sc = 1 + 0.4 * inv;
      var t = 'translate(' + tx + '%, ' + ty + '%) scale(' + sc + ')';
      imgs.forEach(function (i) { i.style.transform = t; });
      var opacity = p < 0.25 ? p / 0.25 : 1;
      contents.forEach(function (c) { c.style.opacity = String(opacity); });
    }
    var raf = null;
    function onScroll() { if (raf) return; raf = requestAnimationFrame(function () { update(); raf = null; }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  // Parallax for [data-endro-parallax]
  function initParallax() {
    var sections = document.querySelectorAll('[data-endro-parallax]');
    if (!sections.length) return;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;
    function update() {
      sections.forEach(function (section) {
        var img = section.querySelector('[data-parallax-img]');
        if (!img) return;
        var intensity = parseFloat(section.getAttribute('data-endro-parallax')) || 60;
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var sectionCenter = rect.top + rect.height / 2;
        var offset = (sectionCenter - vh / 2) / vh;
        var translatePx = offset * -intensity;
        img.style.transform = 'translateY(' + translatePx + 'px)';
      });
    }
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { update(); raf = null; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function disableUnresolved() {
    var d = getData();
    var btns = document.querySelectorAll('[data-endro-action="add"][data-endro-id],[data-endro-action="increment"][data-endro-id]');
    Array.prototype.forEach.call(btns, function (b) {
      var pid = b.getAttribute('data-endro-id');
      var pd = d.products[pid];
      if (pd && !parseInt(pd.variantId, 10)) {
        b.setAttribute('disabled', 'disabled');
        b.classList.add('endro-v3-unresolved');
        var row = b.closest('[data-endro-format-row]');
        if (row) row.classList.add('endro-v3-unresolved-row');
      }
    });
  }
  function init() {
    render();
    disableUnresolved();
    initRecapVisibility();
    initParallax();
    initNaturellement();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.EndroV3 = { state: state, compute: compute, render: render };
})();

// ─────────────────────────────────────────────────────────────────────
// Yotpo : note + nombre d'avis DYNAMIQUES (moyenne pondérée sur les 4 parfums)
// Fallback transparent aux valeurs hardcodées en HTML si l'API échoue.
// ─────────────────────────────────────────────────────────────────────
(function () {
  var APP_KEY = 'DkmWiBrlEO9rvmbb9ce2DkJiSLxCGzz2vYvkUfCW';
  var PRODUCT_IDS = [10080592200027, 10460218884443, 10460219113819, 10460219867483];
  function fetchOne(pid) {
    return fetch('https://api-cdn.yotpo.com/v1/widget/' + APP_KEY + '/products/' + pid + '/reviews.json')
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  Promise.all(PRODUCT_IDS.map(fetchOne)).then(function (all) {
    var sumScore = 0, totalCount = 0;
    all.forEach(function (j) {
      var bl = j && j.response && j.response.bottomline;
      if (bl && bl.total_review > 0) { sumScore += bl.average_score * bl.total_review; totalCount += bl.total_review; }
    });
    if (totalCount === 0) return;
    var avg = (sumScore / totalCount);
    var avgFr = avg.toFixed(2).replace('.', ',');
    document.querySelectorAll('[data-yotpo-score]').forEach(function (el) { el.textContent = avgFr; });
    document.querySelectorAll('[data-yotpo-count]').forEach(function (el) { el.textContent = totalCount.toLocaleString('fr-FR') + ' avis vérifiés'; });
    // hero rating tag aussi si présent
    document.querySelectorAll('[data-yotpo-tag]').forEach(function (el) { el.textContent = '★ ' + avgFr + '/5 · ' + totalCount.toLocaleString('fr-FR') + ' avis'; });
  }).catch(function () { /* silencieux : fallback HTML */ });
})();

  } catch(e) { console.error(e); }
})();
})();
